/**
 * Decode a JWT payload without verification (client-side only).
 * Returns null if the token is malformed.
 */
export function decodeJwtPayload(
  token: string,
): Record<string, unknown> | null {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    const payload = parts[1];
    const decoded = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(decoded);
  } catch {
    return null;
  }
}

/**
 * Check if a JWT token is expired (or will expire within bufferSeconds).
 * Returns true if expired or malformed.
 */
export function isTokenExpired(token: string, bufferSeconds = 60): boolean {
  const payload = decodeJwtPayload(token);
  if (!payload || typeof payload.exp !== "number") return true;
  const expiresAt = payload.exp * 1000; // convert to ms
  return Date.now() >= expiresAt - bufferSeconds * 1000;
}
